export const environment = {
  baseUrl: 'https://regulatory-cms.demo.ukrohost.com',
  production: true,
  api: {
    url: 'https://regulatory-backend.demo.ukrohost.com',
    routes: {
      api: 'api',
      auth: 'auth',
      admin: 'admin',
      front: 'front',
    },
  },
  front: {
    url: 'https://regulatory-portal.demo.ukrohost.com',
  },
}
